var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 50,
    viewBox: "0 0 41 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4676 17.2269C36.1776 19.2421 34.1456 22.6968 34.1456 26.5353C34.1456 30.8536 36.7582 34.7881 40.7255 36.4195C39.9514 38.9145 38.7903 41.2176 37.3388 43.3288C35.21 46.3037 32.9844 49.3745 29.6945 49.3745C26.4045 49.3745 25.4369 47.4552 21.5664 47.4552C17.7926 47.4552 16.4379 49.4705 13.3414 49.4705C10.245 49.4705 8.11622 46.6875 5.69713 43.2329C2.50394 38.4347 0.665428 32.8689 0.568665 27.0151C0.568665 17.5148 6.76153 12.4287 12.9544 12.4287C16.2444 12.4287 18.9537 14.5399 20.9858 14.5399C22.921 14.5399 26.0175 12.3328 29.6945 12.3328C33.565 12.2368 37.242 14.0601 39.4676 17.2269ZM27.9527 8.30231C29.5977 6.38305 30.4686 3.98397 30.5654 1.48893C30.5654 1.20104 30.5654 0.817186 30.4686 0.529297C27.6625 0.817186 25.0498 2.16067 23.2113 4.27186C21.5663 6.09516 20.5987 8.39827 20.502 10.8933C20.502 11.1812 20.502 11.4691 20.5987 11.757C20.7922 11.757 21.0825 11.8529 21.2761 11.8529C23.8887 11.661 26.3078 10.3175 27.9527 8.30231Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.3de1ae4208c4de2f7eb6d479fea0b8e0.svg";
export { ForwardRef as ReactComponent };